/**
 * 서버의 기본 URL을 생성하는 함수
 * 현재 호스트와 알맞은 포트를 포함한 URL을 반환합니다
 * @returns {string} 서버 기본 URL
 */
export const getServerBaseUrl = () => {
  // 개발 환경이면 localhost:8088, 아니면 현재 호스트의 https 사용
  if (isDevelopment()) {
    return process.env.REACT_APP_BASE_URL || `http://localhost:8088`;
  } else {
    return `https://${window.location.hostname}`;
  }
};

/**
 * API 경로에 대한 전체 URL을 생성하는 함수
 * @param {string} path - API 경로 (예: '/api/users')
 * @returns {string} 전체 API URL
 */
export const getApiUrl = (path) => {
  return `${getServerBaseUrl()}${path}`;
};

/**
 * 현재 환경이 개발 환경인지 확인하는 함수
 * @returns {boolean} 개발 환경이면 true, 그렇지 않으면 false
 */
export const isDevelopment = () => {
  return process.env.NODE_ENV === "development";
};
